import React from "react";
import { observer } from "mobx-react-lite";
import { PasswordInput } from "@components-shared/desktop/inputs";

export default observer(function WithdrawalPasswordConfirmation() {
	return (
		<PasswordInput
			name="password"
			className="form__group"
			label={"payment:WITHDRAWAL.PASSWORD_CONFIRM_MESSAGE"}
			placeholder={"COMMON.PASSWORD_CONFIRMATION.PASSWORD_TITLE"}
			required
		/>
	);
});
